module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/departments-list/departments-list.component.scss
// module id = ./src/app/components/departments-list/departments-list.component.scss
// module chunks = main